import { atom } from 'nanostores';

import { generateClientId } from '@/shared/lib';

import type { DebugEvent } from './types';

const MAX_EVENTS = 500;

export const $debugEvents = atom<DebugEvent[]>([]);

export function addDebugEvent(event: Omit<DebugEvent, 'id'>): void {
  const entry: DebugEvent = {
    id: generateClientId(),
    ...event,
  };

  const current = $debugEvents.get();
  const next = [entry, ...current];
  $debugEvents.set(next.length > MAX_EVENTS ? next.slice(0, MAX_EVENTS) : next);
}

export function clearDebugEvents(): void {
  $debugEvents.set([]);
}
